import { createSelector } from 'reselect';
import _ from 'lodash';

export const getUniversities = createSelector(
  state => state.universities.browse,
  state => state.universities.byID,
  (browse, byID) => _.map(browse.IDs, id => {
    const { name, coordinates, _id } = byID[id];
    return { 
      name, 
      coordinates: `${coordinates[0]}, ${coordinates[1]}`,
      _id 
    };
  })
);

export const fetchUniversitiesState = createSelector(
  state => state.universities.browse,
  ({ loading, error }) => ({ loading, error })
);

export const getUniversitiesListRange = createSelector(
  state => state.universities.browse,
  ({ start, end, count }) => ({ start, end, count })
)


// WEBPACK FOOTER //
// ./src/modules/universities/selectors.js